import { isAnyOf } from '@reduxjs/toolkit';
import { HubConnectionState } from '@microsoft/signalr';
import { startListening } from '../state/listenerMiddleware';
import {
  appInBackground,
  appLogout,
  appSync,
  socketConnected,
} from '../state/app/app.slice';
import {
  getSocketConnection,
  createSocketConnection,
} from '../api/createSocketConnection';

startListening({
  actionCreator: appSync,
  effect: async (_, { dispatch }) => {
    const socketConnection = await createSocketConnection();

    if (socketConnection?.state === HubConnectionState.Disconnected) {
      await socketConnection.start();

      dispatch(socketConnected(socketConnection));
    }
  },
});

startListening({
  matcher: isAnyOf(appInBackground, appLogout),
  effect: async () => {
    const socketConnection = await getSocketConnection();

    socketConnection?.stop();
  },
});
